<template lang="pug">
  #login
    WtFullPageLoader(v-if="processingCredentials")
    BNotification.auth-notification(
        :active.sync="error"
        type="is-danger"
        :duration="3000"
      )
        | {{ formErrorMessage || "Hm, there was an error.  Please, try again or contact wellness@be-engaged.co" }}
    .columns.is-flex.is-flex-direction-row.m-0(v-if="registrationFieldsLoaded")
      template(v-if="redirectTo360")
        .section
          .is-size-3 Please visit
            a.pl-2.has-text-blue(:href="programRegistrationFields.terryberryCompanyUrl" target="_blank") {{ programRegistrationFields.terryberryCompanyUrl }}
      .column.is-half-widescreen.is-full-mobile.is-flex.is-flex-direction-column.is-justify-content-center
        .login-box(:class="{'p-4' : isMobile}")
          .box.is-paddingless.logo-box
            WtSvgIcon(v-if="!programRegistrationFields.programLogo" icon="be-well-logo" height="79px" width="79px")
            img(v-else :src="_.get(programRegistrationFields, 'programLogo', '')")
          .box.is-paddingless
            h1.has-text-black.welcome-text.pb-1 {{ programRegistrationFields.name }}
            p.is-size-6.has-text-weight-light Enter your details and log in
          .box.is-centered.is-paddingless.mt-4
            form(@submit.prevent="login")
              .block
                BField(
                  label="Email or Username"
                  label-position="on-border"
                )
                  BInput(
                    v-model="username"
                    name="username"
                    v-validate.disable="'required'"
                    size="is-medium"
                  )
              BField(
                label="Password"
                label-position="on-border"
              )
                BInput(
                  v-model="password"
                  type='password'
                  name="password"
                  size="is-medium"
                  v-validate.disable="'required'"
                  password-reveal
                  autocomplete="off"
                )
              .is-flex.is-justify-content-space-between.mt-3.mb-6
                BCheckbox.is-size-7.is-square(
                  v-model="rememberMe"
                  name="rememberMe"
                  size="is-small"
                ) Remember Me
                WtButton.is-size-7.has-text-weight-bold.has-text-primary.is-paddingless.has-text-right(
                  :isText="true"
                  :isTextUnderlined="false"
                  :isRouterLink="false"
                  @click.native="resetModalOpen = true"
                ) Forgot username or password?
              .is-flex.is-justify-content-space-between.is-align-items-center.is-flex-wrap-wrap    
              WtButton.is-fullwidth(type="submit") Log in
          .is-flex.is-justify-content-start.is-align-items-center(v-if="isRegistrationEnabled")
            p Don't have an account?
            WtButton.is-size-6.registration-button(
              :isText="true"
              :isTextUnderlined="false"
              :isRouterLink="true"
              to="registration"
            ) Register Now
      .column.is-half-widescreen.is-paddingless(v-if="!displayCustomLoginPage && !isMobile")
        img.hero-image(:src="require('@/assets/bewell-hero-image.jpeg')")
      .column.is-half-widescreen.is-flex.is-centered.is-align-items-center(v-if="displayCustomLoginPage && !isMobile")
        .box.bordered-box.custom-content
          WtDisplayRichTextHTML.html-custom-content(:html="programRegistrationFields.customLoginPageContent")
    BModal(
      :active.sync="resetModalOpen"
      has-modal-card
    )
      ForgotPasswordModal
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import ForgotPasswordModal from "@@/Login/ForgotPasswordModal";
import WtFullPageLoader from "@@/WtFullPageLoader/WtFullPageLoader";
import WtTile from "@@/WtTile/WtTile";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import WtProgramLogo from "@@/WtProgramLogo/WtProgramLogo";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "Login",

  components: {
    ForgotPasswordModal,
    WtButton,
    WtFullPageLoader,
    WtTile,
    WtDisplayRichTextHTML,
    WtProgramLogo,
    WtSvgIcon
  },

  data() {
    return {
      username: "",
      password: "",
      rememberMe: false,
      processingCredentials: false,
      error: false,
      formErrorMessage: false,
      resetModalOpen: false,
      fetchRegistrationError: false
    };
  },

  computed: {
    ...mapGetters(["isMobile"]),
    ...mapGetters("registration", [
      "programRegistrationFields",
      "registrationFieldsLoaded"
    ]),

    displayCustomLoginPage() {
      if (this.registrationFieldsLoaded) {
        const programType = this._.get(
          this.programRegistrationFields,
          "type",
          ""
        );
        const isProTier = programType.includes("bewellpro");
        const customLoginEnabled =
          this.programRegistrationFields.customLoginPage &&
          this.programRegistrationFields.customLoginPageContent;
        return !!(isProTier && customLoginEnabled);
      }
      return false;
    },

    redirectTo360() {
      return (
        !this._.isEmpty(this.programRegistrationFields.terryberryCompanyUrl) &&
        !this.$route.query.isWtAdmin
      );
    },

    isRegistrationEnabled() {
      return (
        (!this.programRegistrationFields.isConnectedProgram ||
          this.$route.query.isWtAdmin) &&
        this.programRegistrationFields.allowRegistration
      );
    }
  },

  async mounted() {
    const username = this.$route.query.username;

    if (username) {
      this.username = username;
    }

    const programName = window.location.hostname;

    if (programName) {
      try {
        await this.fetchRegistration({ programName });
        if (this.redirectTo360) {
          window.location.href =
            this.programRegistrationFields.terryberryCompanyUrl + "/wellness";
        }
      } catch (error) {
        this.fetchRegistrationError = error;
      }
    }
  },

  created() {
    // this handles a class form the navbar that gets retained on logout, causing a white margin on top
    document.querySelector("body").classList.remove("has-navbar-fixed-top");
  },

  methods: {
    ...mapActions("registration", ["fetchRegistration"]),

    async login() {
      const validates = await this.$validator.validateAll();
      let params = {
        username: this.username,
        password: this.password,
        rememberMe: this.rememberMe,
        programId: this.programRegistrationFields.id,
        isPartner: 0
      };

      if (!validates) {
        this.processingCredentials = false;
        return;
      }

      // start loading spinner
      this.processingCredentials = true;

      try {
        const redirect = this.$auth.redirect();
        await this.$auth.login({
          data: params,
          // this section returns the member to the url they were attempting
          // before forced authentication.
          redirect: {
            path:
              redirect && redirect.from.name !== "Login"
                ? redirect.from.path
                : "/",
            query: redirect ? redirect.from.query : ""
          }
        });
      } catch (error) {
        this.error = true;
        this.formErrorMessage = error.response.data.error.message;

        this.processingCredentials = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#login
  background-color: $white !important
  position: relative
  min-height: 100vh
  .columns
    width: 100vw !important
    height: 100vh !important
  .column
    height: 100vh !important
    width: 50vw !important
    +mobile
      width: 100% !important
  .block
    margin-bottom: 32px !important
  .hero-image
    border-radius: 12px 0 0 12px
    object-fit: cover !important
    width: 50vw !important
    height: 100%
  .bordered-box
    border: 1px solid lightgray
  .login-box
    justify-content: center !important
    width: 85%
    padding-left: 27%
    border-color: $white
    +mobile
      width: 100% !important
  .logo-box
    img
      max-height: 79px !important
      object-fit: cover
      overflow: hidden
  .welcome-text
    width: 100%
    font-weight: $weight-normal
    font-size: 28px !important
  #wt-full-page-loader
    background-color: $white
    opacity: .8
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 9999

  .registration-button
    color: $black !important
    padding: 2px !important
  .custom-content
    height: 500px !important
    overflow: scroll
  .html-custom-content
    width: 100%
</style>
